import { frontendURL } from '../../../../helper/URLHelper';

const sources = accountId => ({
  parentNav: 'sources',
  routes: [
    'documents_sources',
    'questions_sources',
    'webs_sources',
    'webs_sources_detail',
  ],
  menuItems: [
    {
      icon: 'document-sources',
      label: 'SOURCES.DOCUMENT',
      key: 'documentSources',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/sources/documents`),
      toStateName: 'documents_sources',
    },
    {
      key: 'questionsSources',
      icon: 'question-sources',
      label: 'SOURCES.QUESTION',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/sources/questions`),
      toStateName: 'questions_sources',
    },
    // {
    //   key: 'websSources',
    //   icon: 'web-sources',
    //   label: 'SOURCES.WEB',
    //   hasSubMenu: false,
    //   toState: frontendURL(`accounts/${accountId}/sources/webs`),
    //   toStateName: 'webs_sources',
    // },
  ],
});

export default sources;
